var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4597 10.6694L9.29985 9.12308V5.97313C9.29985 5.6564 9.03166 5.40039 8.69988 5.40039C8.3681 5.40039 8.09991 5.6564 8.09991 5.97313V9.40948C8.09991 9.58988 8.18871 9.75999 8.3399 9.86767L10.7397 11.5858C10.8433 11.6603 10.9694 11.7005 11.0991 11.7004C11.2821 11.7004 11.4621 11.6219 11.5797 11.4707C11.7789 11.2181 11.7249 10.859 11.4597 10.6694Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9999 0.900391C4.53329 0.900391 0.899902 4.53378 0.899902 9.00039C0.899902 13.467 4.53329 17.1004 8.9999 17.1004C13.4665 17.1004 17.0999 13.467 17.0999 9.00039C17.0999 4.53378 13.4665 0.900391 8.9999 0.900391ZM8.9999 15.8456C5.22597 15.8456 2.15474 12.7743 2.15474 9.00039C2.15474 5.22646 5.22597 2.15523 8.9999 2.15523C12.7745 2.15523 15.8451 5.22646 15.8451 9.00039C15.8451 12.7743 12.7738 15.8456 8.9999 15.8456Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockActive);
export default __webpack_public_path__ + "static/media/clock_active.d7ae5cec315d05448fbe98b2be3b0a9b.svg";
export { ForwardRef as ReactComponent };